//                         protocol                   .com         cars/ or cars  taxonomy/   <        remainder        ><   withfeatures            >
// eslint-disable-next-line
export const regexUrl = /(?:http(?:s)?:\/\/)?(?:[\w.]*.com\/)?(?:(?:cars\/|cars$))([\w-]*\/)?((?!with-).+?(?=(?:with|$)))?(with-.+?(?=(?:$)))?(?:-)?/;
export const yearRegex = /^(19|20)\d{2}$/;
export const locationRegex = /^in-([-\w]+)-(\w{2})$/;
export const endsWithStateRegex = /(?:-)(\w{2})$/;
export const regexMatchUrlWithLocation = /(.+)[-/]{1}((?!-\w{2}$)in-([-\w]+)(?:(?:-(\w{2}))))/;
export const regexMatchUrlWithLocationNoState = /(.+)[-/]{1}((?!-\w{2}$)in-([-\w]+))()/;
export const defaultCarsRegex = /cars$/;

export const startValueRank = 100;
export const rankDecrementStep = 10;
export const maxRank = 1000;
export const locationRank = 1000;
export const taxonomyRank = 1000;

// dissectUrlWithWeights props we want to return in the results
export const projectedResultProps = ['value', 'rank', 'isRequired', 'isLocation'];

export const defaultSearchResult = [
  { value: 'used car online', rank: maxRank, isRequired: false },
  { value: 'used car sales', rank: 900, isRequired: false },
  { value: 'car', rank: 400, isRequired: false }
];
